import { QuestionMarkCircleIcon } from "@heroicons/react/outline";

import { useIsReadonly } from "@/components/PowerBlock/Block/readonly-context";
import { Toggle } from "@/components/Toggle";
import { Skeleton } from "@/components/ui/skeleton";
import { BasicTooltip } from "@/components/ui/Tooltip";

interface ReturnTemplateOnlyToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  isLoading?: boolean;
}

const ReturnTemplateOnlyToggle = ({
  enabled,
  onChange,
  isLoading = false,
}: ReturnTemplateOnlyToggleProps) => {
  const isReadonly = useIsReadonly();

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-1">
        <span className="text-sm text-gray-700">Return Template Only</span>
        <BasicTooltip content="When enabled, returns the raw prompt template structure without executing the LLM. No model configuration or input variable mapping is required.">
          <QuestionMarkCircleIcon className="h-4 w-4 text-gray-400" />
        </BasicTooltip>
      </div>
      {isLoading ? (
        <Skeleton width={44} height={24} borderRadius={12} />
      ) : (
        <Toggle enabled={enabled} setEnabled={onChange} disabled={isReadonly} />
      )}
    </div>
  );
};

export default ReturnTemplateOnlyToggle;
